module.exports = __webpack_public_path__ + "static/media/login_side_image.1b39db30.png";